import { defineMessages } from 'react-intl';
import type { AtaAzureServiceEnum } from '@foundershub/api-client';

export const ataAzureServiceLabels = defineMessages<AtaAzureServiceEnum>({
  'architecture-review': {
    defaultMessage: 'Architecture Review',
    description: 'Azure Technical Advisory service label',
  },
  'getting-started-with-azure': {
    defaultMessage: 'Getting Started in Azure',
    description: 'Azure Technical Advisory service label',
  },
  'cost-optimization-guidance': {
    defaultMessage: 'Cost Optimization',
    description: 'Azure Technical Advisory service label',
  },
  'migrating-replacing-current-cloud-provider': {
    defaultMessage: 'Migrations',
    description: 'Azure Technical Advisory service label',
  },
  'artificial-intelligence': {
    defaultMessage: 'Azure Artificial Intelligence/Machine Learning',
    description: 'Azure Technical Advisory service label',
  },
  'azure-iaas-vm-storage-networking': {
    defaultMessage: 'Azure IaaS (VM, Storage, Networking)',
    description: 'Azure Technical Advisory service label',
  },
  'azure-app-service': {
    defaultMessage: 'Azure App Service',
    description: 'Azure Technical Advisory service label',
  },
  'azure-container-kubernetes-services': {
    defaultMessage: 'Azure Container & Kubernetes Services',
    description: 'Azure Technical Advisory service label',
  },
  'azure-databases-analytics': {
    defaultMessage: 'Azure Databases & Analytics',
    description: 'Azure Technical Advisory service label',
  },
  'azure-security-identity': {
    defaultMessage: 'Azure Security & Identity',
    description: 'Azure Technical Advisory service label',
  },
  'devops-on-azure': {
    defaultMessage: 'DevOps on Azure',
    description: 'Azure Technical Advisory service label',
  },
  other: {
    defaultMessage: 'Other',
    description: 'Azure Technical Advisory service label',
  },
});
